const DataPengumuman = [
  {
    id: "1",
    status: "warning",
    title: "Pelatihan Fisik",
    text: "Dilaksanakan pada Sabtu, 17 Oktober 2020 di Belakang Tugu UNJ",
  },
  {
    id: "2",
    status: "info",
    title: "Materi Pendidikan dan Pelatihan (Diklat I)",
    text:
      "Dilaksanakan pada Sabtu, 17 Oktober 2020 di Sekretariat KSR PMI Unit UNJ",
  },
  {
    id: "3",
    status: "info",
    title: "Materi Pendidikan dan Pelatihan (Diklat II)",
    text:
      "Dilaksanakan pada Sabtu, 24 Oktober 2020 di Sekretariat KSR PMI Unit UNJ",
  },
  {
    id: "4",
    status: "info",
    title: "Materi Pendidikan dan Pelatihan (Diklat III)",
    text:
      "Dilaksanakan pada Sabtu, 31 Oktober 2020 di Sekretariat KSR PMI Unit UNJ",
  },
];

export default DataPengumuman